import React, { useState } from 'react';
import { useQuery } from "@tanstack/react-query";
import { Modal,  Row, Col, Card, Placeholder } from 'react-bootstrap';
import { MaintenanceApi } from '../../app/api/maintenance.api';


export function CancelModal({ show, onHide, maintenance, refetch })
{
  
    const maintenances = MaintenanceApi();
  
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); 
  
  
    const handleConfirm = async ()=>{
  
      setStatus(0);
      setIsLoading(true);
  
      try {
          const {data} = await maintenances.update( maintenance?.id, { status : 'canceled' } );
          if( data.success ){
              setStatus(1);
              setMessage(data.message);
              refetch();
          }
          else{
              setStatus(-1);
              setMessage('Erreur ! veuillez réessayer');
          }
      } catch (err) { 
          
          setStatus(-1);
          setMessage(err?.response?.data.message);
      } finally{
          setIsLoading(false);
      }
    }


    return(
      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5">
            <i className="bi bi-x-circle text-danger me-2"></i>
            Annulation de maintenance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <div className="text-center">
            <i className="bi bi-chat-left-check text-green" style={{ fontSize: '3rem' }}></i>
            <p className="mt-3 text-secondary">
              Confirmez-vous que vous vous apprêtez à annuler cette commande de maintenance ?
            </p>
            <p className="text-muted fs-2">
              <i className="bi bi-tools"> </i> 
            </p>
            {
              isLoading && (
                <div className="d-flex justify-content-center mb-2"> 
                  <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="alert alert-success mb-2 small w-100"> { message } </div>
              )
            }
            {
              status === -1 && (
                <div className="alert alert-danger mb-2 small w-100"> { message } </div>
              )
            }
          </div>
        </Modal.Body>
        <Modal.Footer className="border-top gap-2">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
          <button className="btn btn-sm btn-green" onClick={handleConfirm}>
            <i className="bi bi-check-circle me-2"></i>
            Confirmer
          </button>
        </Modal.Footer>
      </Modal>
    )
}



export function EditMaintenanceModal({ show, onHide, maintenance, refetch })
{
    
    const maintenances = MaintenanceApi();

    const [checked, setChecked] = useState(false);
    const [price, setPrice] = useState(0);
  
    const [status, setStatus] = useState(0);
    const [message, setMessage] = useState("");
    const [isLoading, setIsLoading] = useState(false); 
  
  
    const handleSubmit = async (e) => {

      e.preventDefault();
      setStatus(0);
      setIsLoading(true);
  
      try {
          const {data} = await maintenances.updateOne( maintenance?.id, { status : 'done', price : price } );
          if( data.success ){
              setStatus(1);
              setMessage(data.message);
              refetch();
          }
          else{
              setStatus(-1);
              setMessage('Erreur ! veuillez réessayer');
          }
      } catch (err) { 
          
          setStatus(-1);
          setMessage(err?.response?.data.message);
      } finally{
          setIsLoading(false);
      }
    }


    return(

      <Modal show={show} onHide={onHide} centered backdrop="static">
        <Modal.Header closeButton className="border-bottom">
          <Modal.Title className="text-green fs-5">
            <i className="bi bi-check-circle-fill text-green me-2"></i>
            Validation maintenance
          </Modal.Title>
        </Modal.Header>
        <Modal.Body className="py-4">
          <form className="d-flex flex-column justify-content-center p-4" onSubmit={ handleSubmit }>
            {
              isLoading && (
                <div className="d-flex justify-content-center mb-2"> 
                  <div className="spinner-border text-green" role="status" aria-label="Chargement"></div>
                </div>
              )
            }
            {
              status === 1 && (
                <div className="alert alert-success mb-2 small w-100"> { message } </div>
              )
            }
            {
              status === -1 && (
                <div className="alert alert-danger mb-2 small w-100"> { message } </div>
              )
            } 
            <span className="small text-secondary mb-1"> Montant de la maintenance </span>
            <div className="d-flex align-items-center mb-3"> 
               <input type="number" className="w-100 p-2 bordertext-muted" placeholder='200000' name="price" onChange={ e => setPrice( e.target.value ) } />
               <span className="text-secondary p-2 bg-light border"> Fcfa </span>
            </div>

            <input type="checkbox" checked={checked} onChange={(e) => setChecked(e.target.checked)} name="name" style={{ width: '20px', height: '20px' }} />
            <span className="small text-secondary mb-1"> Etes vous sure de vouloir modifier le Statut de cet utilisateur </span>
            
            <button className="btn btn-green mt-3" disabled={!checked} > Enregistrer <i className="bi bi-chevron-right ms-1"></i> </button>

          </form>
        </Modal.Body>
        <Modal.Footer className="border-top d-flex gap-2 px-4">
          <button className="btn btn-sm btn-outline-danger" onClick={onHide}>  Annuler </button>
        </Modal.Footer>
      </Modal>
    )
}





export function StatContainer()
{
    const maintenance = MaintenanceApi(); 

    const fetchData = async () => { 
      const {data} = await maintenance.getCount();
      return data.data; 
    }
    const { isLoading, data=[], error } = useQuery({  queryKey: ["maintenancesStats"], queryFn: fetchData });


    if (isLoading){
      return (
        <Row className="g-4">
        {
          Array.from({ length: 3 }).map((_, index) => (
            <Col key={index} lg={4} md={4} sm={6} xs={12}>
              <Placeholder as="div" animation="glow" className="w-100 bg-secondary bg-opacity-25 rounded" style={{ height: '140px' }} />
            </Col>
          ))
        }
        </Row>
      )
    };
    if (error){
      return(
        <div className="text-center p-4 border alert alert-danger w-100">
          Une erreur est survenue. Vueiller vérifier votre connexion 
        </div>
      )
    }

    return(

      <Row className="g-4">

        <Col lg={4} md={4} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-2 mb-2" > {data.pending} </div>
              <div className="text-secondary"> Maintenance en cours </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} md={4} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-2 mb-2" > {data.done} </div>
              <div className="text-secondary"> Maintenance réalisée </div>
            </Card.Body>
          </Card>
        </Col>
        <Col lg={4} md={4} sm={6} xs={12}>
          <Card className="stat-card h-100 rounded-0 border">
            <Card.Body className="text-center">
              <div className="stat-value text-secondary fs-2 mb-2" > {data.canceled} </div>
              <div className="text-secondary"> Maintenance annulée </div>
            </Card.Body>
          </Card>
        </Col>
        
      </Row>

    )
}

